export default {
  meta: {
    title: '评分表洞察',
    url: '/brain/gradeinsight', // 埋点用，记录所属模块
    // eventId: '66088c5b-2678-4b31-acc2-feea1dab828e'
  },
};
